$( "#addtocart" ).click(function() {
  
  $('form[action="/cart"]').submit(function(){
  $.getJSON( "/cart.js", function(data) {
   // alert('There are now ' + data.price + ' items in the cart.');
   // debugger;
    
    var items = [];
    $.each( data.items, function( key, val ) {
      debugger;
      var p_name= val.title;
      var qunt = val.quantity;
      var variant_ids = val.variant_id;
      var price = Math.abs(val.price/100);
      var prop = val.properties;
      
       

      
      if(amount == "" || !amount)
      {
         items.push({
          "title": p_name,
          "quantity": qunt,
          //"variant_id": variant_ids,
          "price": price
        });

      }else
      {
        items.push({
          "title": p_name,
          "quantity": qunt,
          //"variant_id": variant_ids,
          "price": price,
          "properties": [prop]

        });
      }

     // items.push( "<li id='" + key + "'>" + val + "</li>" );
      //console.log( "<li id='" + key + "'>" + val + "</li>" );
     // console.log(val.properties.Personalization_Charges);
      //console.log(val.title);
    });

     var dataString = JSON.stringify(items);  
       console.log(dataString);

     $.ajax({
     url: 'https:/webtesttrendy.com/designnbuy/pcstudio_config/create_draft_order',
     data: {myData: dataString},
     type: 'POST',
     success: function(response) {
      // alert(response);
      // console.log(response);
       if(response != "" || response != undefined){
         window.location.href = response;

       //console.log(response)
       }
     }
  });

  })
    .done(function() {
      console.log( "second success" );
    })
    .fail(function() {
      console.log( "error" );
    })
    .always(function() {
      console.log( "complete" );
    });
    return false; 
  });
  
   
   
 });